import { useTranslation } from "react-i18next";
import { GALLERY_IMAGES } from "../../data/experiences";
import Reveal from "../Reveal";

export default function Gallery() {
  const { t } = useTranslation();
  return (
    <section className="bg-bone py-24 lg:py-40" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end mb-16 lg:mb-20">
          <div className="md:col-span-8">
            <div className="text-xs uppercase tracking-wider-3 text-moss mb-6 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-moss" />
              {t("gallery.eyebrow")}
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl text-forest leading-[1.04]">
              {t("gallery.title_a")} <span className="italic">{t("gallery.title_b")}</span>
            </h2>
          </div>
        </Reveal>
      </div>

      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-3 md:gap-4">
          {GALLERY_IMAGES.map((src, i) => {
            const widths = ["col-span-12 md:col-span-7", "col-span-12 md:col-span-5",
                           "col-span-6 md:col-span-4", "col-span-6 md:col-span-4", "col-span-12 md:col-span-4",
                           "col-span-6 md:col-span-5", "col-span-6 md:col-span-4", "col-span-12 md:col-span-3"];
            const heights = ["aspect-[4/3]", "aspect-[3/4]", "aspect-square", "aspect-square", "aspect-[3/4]",
                            "aspect-[4/3]", "aspect-square", "aspect-[3/4]"];
            return (
              <Reveal key={i} delay={(i % 4) * 80} className={`group ${widths[i % widths.length]} overflow-hidden bg-stone-warm`}>
                <div className={`${heights[i % heights.length]} relative overflow-hidden`}>
                  <img src={src} alt={t("gallery.title_a") + " " + (i + 1)} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover cine-img" />
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
